/** Cadre circulaire page partenaire (identique au front public). */
export const PARTNER_LOGO_CIRCLE_FRAME = '/assets/partner-logo-circle.svg';

export const PARTNER_LOGO_CIRCLE_SLOT = {
  top: '46%',
  left: '50%',
  width: '103%',
  height: '58%',
} as const;

export const PARTNER_LOGO_CIRCLE_LAYER = {
  frame: 1,
  logo: 2,
} as const;

export type PartnerLogoCircleLayout = {
  scale: number;
  offsetX: number;
  offsetY: number;
};

export const DEFAULT_PARTNER_LOGO_CIRCLE_LAYOUT: PartnerLogoCircleLayout = {
  scale: 1,
  offsetX: 0,
  offsetY: 0,
};

export function normalizePartnerLogoCircleLayout(
  raw?: Partial<PartnerLogoCircleLayout> | null
): PartnerLogoCircleLayout {
  const scale = typeof raw?.scale === 'number' && Number.isFinite(raw.scale) ? raw.scale : 1;
  const offsetX = typeof raw?.offsetX === 'number' && Number.isFinite(raw.offsetX) ? raw.offsetX : 0;
  const offsetY = typeof raw?.offsetY === 'number' && Number.isFinite(raw.offsetY) ? raw.offsetY : 0;
  return {
    scale: Math.min(4, Math.max(0.25, scale)),
    offsetX: Math.min(50, Math.max(-50, offsetX)),
    offsetY: Math.min(50, Math.max(-50, offsetY)),
  };
}
